
import { Component, Mixins } from "vue-property-decorator";
import { ObjectUtility, UuidFactory } from "../../../../../base/utilities";
import { IQuestionnaire } from "../../../../../documaker/domain/format/objects";
import { IConfiguration } from "../../../../domain/configuration";
import { FormatPageStructureEditor, IFormatObjectEditable } from "../../../../domain/editableFormat";
import { instanceOfIQuestionnairePropertyEditable } from "../../../../domain/editableFormat/properties";
import { QuestionnaireGuidTreeEditor, QuestionnaireGuidTree } from "../../../../domain/questionnaire";

@Component
export default class QuestionnaireGuidAssignableMixin extends Mixins() {
  $configuration!: IConfiguration;

  toNewGuidDictionaryForQuestionnaire(sources: IFormatObjectEditable[]): { [key in string]: string } {
    const results: { [key in string]: string } = {};
    if (this.$configuration.formatEditor.extensions.questionnaire.isEnable) {
      sources.map(s => instanceOfIQuestionnairePropertyEditable(s) ? s.questionnaire().getValue()._guid : null)
        .filter(g => !!g)
        .forEach(g => results[g] = UuidFactory.create());
    }
    return results;
  }

  assignNewGuidForQuestionnaire(source: IFormatObjectEditable, guidDictionary?: { [key in string]: string }): string {
    if (this.$configuration.formatEditor.extensions.questionnaire.isEnable && instanceOfIQuestionnairePropertyEditable(source) && (0 < source.selectableQuestionnaireTypes().length)) {
      // Questionnaire拡張時は_guidを採番する.
      const updated: IQuestionnaire = { ...source.questionnaire().getValue() };
      updated._guid = (guidDictionary && guidDictionary[updated._guid])
        ? guidDictionary[updated._guid]
        : UuidFactory.create();
      updated._childGuids = guidDictionary
        ? updated._childGuids.filter(g => guidDictionary[g]).map(g => guidDictionary[g])
        : [];
      source.questionnaire().setValue(updated);
      return updated._guid;
    }
    return null;
  }

  toRootGuidsForQuestionnaire(sources: IFormatObjectEditable[]): string[] {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable
      ? QuestionnaireGuidTree.from(sources).filter(v => !v.parent).map(v => v.guid)
      : [];
  }

  addQuestionnaireChildGuids(source: FormatPageStructureEditor, index: number, isHitObject: boolean, childGuids: string[]): number {
    if (this.$configuration.formatEditor.extensions.questionnaire.isEnable && typeof index === "number" && childGuids) {
      const editor = new QuestionnaireGuidTreeEditor(source);
      if (isHitObject) {
        const object = editor.objects[index - 1];
        if (instanceOfIQuestionnairePropertyEditable(object)) {
          const questionnaire = object.questionnaire().getValue();
          this.updateQuestionnaireChildGuids(source, object, questionnaire._childGuids.concat(childGuids));
          return index + questionnaire._childGuids.length;
        }
      } else {
        const parentTree = editor.toParentGuidTreeItem(index, editor.items);
        if (parentTree && !parentTree.isLastChild) {
          const prev = parentTree.parent.children.slice(0, parentTree.childIndex).map(c => c.guid);
          const next = parentTree.parent.children.slice(parentTree.childIndex, parentTree.parent.children.length).map(c => c.guid);
          const marged = prev.concat(childGuids, next).filter(c => !!c);
          this.updateQuestionnaireChildGuids(source, parentTree.parent.source, marged);
        }
      }
    }
    return index;
  }

  private updateQuestionnaireChildGuids(source: FormatPageStructureEditor, object: IFormatObjectEditable, childGuids: string[]) {
    if (!instanceOfIQuestionnairePropertyEditable(object)) {
      return;
    }
    const clone = ObjectUtility.copyDeeply(object.questionnaire().getValue()) as IQuestionnaire;
    clone._childGuids = childGuids;
    object.questionnaire().setValue(clone);
    source.updateObject(object);
  }
}
